export const ORG_ADMINS_MANAGERS_ONLY = 'o';
export const TEAM_ADMINS_MANAGERS = 't';
export const EACH_USER = 'u';
